exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".VHARepresentation {\n  overflow: auto; }\n\n.VHARepresentationBlock {\n  width: 50%;\n  float: left;\n  margin-bottom: 24px; }\n  .VHARepresentationBlock:nth-child(2n + 1) {\n    clear: both; }\n\n.VHARepresentationBlockContent {\n  width: 50%;\n  float: left;\n  margin-bottom: 16px; }\n  .VHARepresentationBlockContent.isWide {\n    width: 100%; }\n", ""]);

// exports
